module.exports = __webpack_public_path__ + "media/images/favicon-245584a40ae15b58a63e0dca500d5e28.ico";